
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="py-20 px-6 bg-slate-50 border-t border-slate-100">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl font-bold mb-6">Work With Our Team</h2>
        <p className="text-lg text-muted-foreground mb-10">
          Ready to collaborate with our experts? Contact us today to discuss your project or schedule a call with our co-founders.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link 
            to="/contact" 
            className="px-8 py-3 rounded-full bg-primary text-white font-medium shadow-lg hover:shadow-xl hover:bg-primary/90 transition-all"
          >
            Book a Call
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
